import classNames from "classnames";
import { FilterContext } from "components/filters/FilterContext";
import moment from "moment";
import React, { useContext } from "react";
import { useViewport } from "utilities/hookutils";
import { flatWeekList } from "../periodfilter/timeutils";
import { getPageNumbers } from "utilities/paginationUtils";

export const WeekNavigationFilter = () => {
  const filterContext = useContext(FilterContext);
  const week = filterContext.getValue("week");
  const viewport = useViewport();

  let pagesBeforeAndAfterCenterPoint = 3;
  switch (viewport) {
    case "mobile":
      pagesBeforeAndAfterCenterPoint = 1;
      break;
    case "desktopSmall":
      pagesBeforeAndAfterCenterPoint = 3;
      break;
    default:
      pagesBeforeAndAfterCenterPoint = 5;
      break;
  }

  const onGoToWeek = (week: moment.Moment) => {
    filterContext.setValue("week", { week });
  }

  if (week.week == null) {
    return null;
  }

  const list = [0, ...flatWeekList()];
  const currentTime = week.week.valueOf();
  const currentIndex = list.findIndex(x => x >= currentTime);
  const entries = getPageNumbers(currentIndex, list.length - 1, pagesBeforeAndAfterCenterPoint);
  const index = entries.findIndex(x => x === currentIndex);
  const weeks = entries.map(x => moment.utc(list[x]));

  return <div className="pagination_small">
    <div className="pages">
      {weeks.map((w, idx) => {
        const numberClasses = classNames({
          current: idx === index,
        });

        return <div
          key={w.week()}
          onClick={() => { onGoToWeek(w) }}
          className={numberClasses}>
          W{w.format("w YY")}
        </div>;
      })}
    </div>
  </div>
};
